<template>
  <div class="layout">
    <app-header />
    <div class="layout-page">
      <router-view />
    </div>
  </div>
</template>

<script>
import AppHeader from './AppHeader.vue'
export default { name: 'Layout', components: { AppHeader } }
</script>

<style lang="less" scoped>
@import '../styles/tokens.less';
.layout { height: 100%; display: flex; flex-direction: column; background: @bg-page; }
.layout-page { flex: 1; min-height: 0; overflow: auto; padding: 4px 10px 10px; }
</style>
